import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { CellPhone, Phone, PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { AllDistrictsWithChildrenViewModel, DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";
import { CitySelectorViewModel } from "src/Financial/cityManipulation/cityManipulation-viewModel";
import { ProvinceSelectorViewModel } from "src/Financial/provinceManipulation/provinceManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { CreateCustomerCreationRequestView } from "./createCustomerCreationRequest-view"
import { CustomerAttributeLicenseSelectorViewModel, CustomerAttributeProfessionSelectorViewModel, CustomerAttributeWorkingAreaSelectorViewModel } from "../customerAttribute/customerAttributesSelector-viewModel";

export class CreateCustomerCreationRequestViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel, needConfirm = true) {
        super(parentViewModel);
        this.needConfirm = needConfirm;
        this.citySelector = new CitySelectorViewModel(this);
        this.provinceSelector = new ProvinceSelectorViewModel(this);
        this.customerAttributeLicense = new CustomerAttributeLicenseSelectorViewModel(this);
        this.customerAttributeProfession = new CustomerAttributeProfessionSelectorViewModel(this);
        this.customerAttributeWorkingArea = new CustomerAttributeWorkingAreaSelectorViewModel(this);
        this.districtSelector = new AllDistrictsWithChildrenViewModel(this);
        this.provinceSelector.onSelectionChanged = x=> {
            this.citySelector.provinceId = x?.id
        };
        this.phoneInput = new PhoneInputViewModel(this);
    }
    
    closePopup(resultCode: string = null) {
    }

    GetDefaultView(): View <ViewModel> {
        return new CreateCustomerCreationRequestView();
    }
    public getTypeId(): string {
        return "VM-2483DFF0-D18D-4311-A514-393DA2DC0D57"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastname(v: string) { this._lastname = v; } public get lastname(): string { return this._lastname;} private _lastname: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set districtSelector(v: AllDistrictsWithChildrenViewModel) { this._districtSelector = v; } public get districtSelector(): AllDistrictsWithChildrenViewModel { return this._districtSelector;} private _districtSelector: AllDistrictsWithChildrenViewModel;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set needConfirm(v: boolean) { this._needConfirm = v; } public get needConfirm(): boolean { return this._needConfirm;} private _needConfirm: boolean;
    
    public set customerAttributeLicense(v: CustomerAttributeLicenseSelectorViewModel) { this._customerAttributeLicenseViewModel = v; } public get customerAttributeLicense(): CustomerAttributeLicenseSelectorViewModel { return this._customerAttributeLicenseViewModel;} private _customerAttributeLicenseViewModel: CustomerAttributeLicenseSelectorViewModel;
    public set customerAttributeProfession(v: CustomerAttributeProfessionSelectorViewModel) { this._customerAttributeProfessionViewModel = v; } public get customerAttributeProfession(): CustomerAttributeProfessionSelectorViewModel { return this._customerAttributeProfessionViewModel;} private _customerAttributeProfessionViewModel: CustomerAttributeProfessionSelectorViewModel;
    public set customerAttributeWorkingArea(v: CustomerAttributeWorkingAreaSelectorViewModel) { this._customerAttributeWorkingAreaViewModel = v; } public get customerAttributeWorkingArea(): CustomerAttributeWorkingAreaSelectorViewModel { return this._customerAttributeWorkingAreaViewModel;} private _customerAttributeWorkingAreaViewModel: CustomerAttributeWorkingAreaSelectorViewModel;
    public set provinceSelector(v: ProvinceSelectorViewModel) { this._provinceSelectorViewModel = v; } public get provinceSelector(): ProvinceSelectorViewModel { return this._provinceSelectorViewModel;} private _provinceSelectorViewModel: ProvinceSelectorViewModel;
    public set provinceId(v: string) { this._provinceId = v; } public get provinceId(): string { return this._provinceId;} private _provinceId: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName;} private _provinceName: string;
    
    public set citySelector(v: CitySelectorViewModel) { this._citySelector = v; } public get citySelector(): CitySelectorViewModel { return this._citySelector;} private _citySelector: CitySelectorViewModel;
    public set cityId(v: string) { this._cityId = v; } public get cityId(): string { return this._cityId;} private _cityId: string;
    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName;} private _cityName: string;
    
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    
    async save () {
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست');
                return;
            }
            this.isLoading = true;
            let phones = this.phoneInput.getPhones();
            let cellPhones = this.phoneInput.getCellPhones();
            let result = await ServerConnection.callServer('/Complex/CrmServices/CreateCustomerRequest',{
                NeedConfirm: this.needConfirm,
                Name: this.name,
                LastName: this.lastname,
                NationalCode: this.nationalCode,
                Comment: this.comment,
                Address: this.address,
                Province: this.getProvinceId(),
                DistrictId: this.getDistrictId(),
                City: this.getCityId(),
                AttributeValues: [
                    this.getCustomerAttributeLicense(),
                    this.getCustomerAttributeProfession(),
                    this.getCustomerAttributeWorkingArea()
                ],
                Phones: phones.map((q,i)=>{
                    return {
                        Index : i+1,
                        CountryCode : q.countryCode,
                        CityCode: q.cityCode,
                        Number: q.number
                    }
                }),
                CellPhones: cellPhones.map((q,i)=>{
                    return {
                        Index : i+1,
                        CountryCode : q.countryCode,
                        Number: q.number
                    }
                })
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            await this.messageBoxConfirmSuccess('درخواست ایجاد مشتری جدید با موفقیت انجام شد.','عملیات موفق');
            this.closePopup();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push(' نام مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.lastname)){
            result.push(' نام خانوادگی مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getCityId())){
            result.push(' شهر مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getProvinceId())){
            result.push(' استان مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getDistrictId())){
            result.push(' شعبه مشخص نشده است.')
        }
        if(this.phoneInput.getCellPhones().length <= 0){
            result.push('حداقل یک شماره همراه باید ثبت شود.')
        }
        return result;
    }

    getCustomerAttributeWorkingArea() {
        return {
            Id: this.customerAttributeWorkingArea.selectedItem?.id,
            Name: this.customerAttributeWorkingArea.selectedItem?.title
        };
    }

    getCustomerAttributeLicense() {
        return {
            Id: this.customerAttributeLicense.selectedItem?.id,
            Name: this.customerAttributeLicense.selectedItem?.title
        };
    }

    getCustomerAttributeProfession(): object {
        return {
            Id: this.customerAttributeProfession.selectedItem?.id,
            Name: this.customerAttributeProfession.selectedItem?.title
        };
    }

    getDistrictId() {
        return this.districtSelector.selectedItem?.id;
    }

    getProvinceId() {
        return this.provinceSelector.selectedItem?.id;
    }
    
    getCityId() {
        return this.citySelector.selectedItem?.id;
    }
    
}